

























































import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import { IImage, IImageUpdateRequest } from "@/types/image";
import { ImageUpdateRequest } from "@/models/image";
import { IUser } from "@/types/user";
import { IStageListRequest } from "@/types/stage";
import { ISelectItem } from "@/types";

@Component({
  components: {}
})
export default class extends Vue {
  @Action("image/get")
  public getImage!: (image_id: number) => boolean;

  @Action("image/update")
  public update!: (data: {
    image_id: number;
    params: IImageUpdateRequest;
  }) => boolean;

  @Getter("image/single")
  public image!: IImage;

  @Mutation("image/clear")
  public clear!: () => void;

  @Action("image/delete")
  public delete!: (image_id: number) => boolean;

  @Action("stage/getList")
  public getStages!: (params: IStageListRequest) => Promise<boolean>;
  @Getter("stage/selectItem")
  public stages!: ISelectItem[];

  @Getter("auth/me")
  public user!: IUser;

  public rules = {
    file: [
      (file: File) =>
        !file || file.size < 15 * 1024 * 1024 * 1024 || "写真は一つ15GBまでです"
    ],
    memo: [
      (v: string) =>
        !v || v.length <= 50 || "メモは50文字以下で入力してください"
    ]
  };

  public image_id = 0;
  public valid = true;
  public lazy = false;

  public params: IImageUpdateRequest = new ImageUpdateRequest();

  //--------
  // コンポーネント作成時実行
  public async created() {
    this.image_id = Number(this.$route.params.image_id);
    this.clear();

    await Promise.all([
      this.getImage(this.image_id),
      this.getStages({ company_id: this.user.company_id })
    ]);
    this.setDefault();
  }

  //--------
  // 更新時デフォルト値をセットする
  private setDefault() {
    this.params = {
      url: this.image.url,
      id: this.image.id,
      stage_id: this.image.stage_id,
      memo: this.image.memo,
      upload_file: "",
      is_published: this.image.is_published
    };
  }

  //--------
  // ファイルが選択されたときの挙動
  public fileChanged(event: Event) {
    const $file = event.target as HTMLInputElement;
    const files = $file.files || [];
    if (files.length === 0) {
      return;
    }

    const file = files[0];
    if (!/^image/.test(file.type)) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      this.params.upload_file = reader.result as string;
      this.params.url = reader.result as string;
    };
  }

  //--------
  // 確定ボタンが押された際の挙動
  public async submit() {
    const result = await this.update({
      image_id: this.image_id,
      params: this.params
    });

    if (result) {
      this.$router.go(-1);
    }
  }

  public async deleteImage() {
    const result = await this.delete(this.image_id);
    if (result) {
      this.$router.go(-1);
    }
  }
}
